export type AddedItem = { text: string; filter: string | null };

export function readAddedItems($row: JQuery): AddedItem[] {
  return $row.find('.ads-pool-added-items .ads-pool-added-item').map(function() {
    const $el = $(this);
    const text = String($el.attr('data-text') ?? '').trim();
    const filter = $el.attr('data-filter');
    return { text, filter: filter ? filter : null };
  }).get().filter(item => item.text !== '');
}

export function readRange($row: JQuery): { min: number | null; max: number | null } {
  const parse = (raw: unknown) => {
    const n = parseInt(String(raw ?? ''), 10);
    return Number.isFinite(n) ? n : null;
  };
  return {
    min: parse($row.find('[data-range="min"]').val()),
    max: parse($row.find('[data-range="max"]').val()),
  };
}

export function createListItem(text: string, filter: string | null, filterLabel: string | null): JQuery {
  const $item = $('<div class="ads-pool-added-item"></div>').attr('data-text', text);
  if (filter) $item.attr('data-filter', filter);
  $('<b class="mr-1"></b>').text(text).appendTo($item);
  if (filterLabel) $item.append(document.createTextNode(`(${filterLabel})`));
  $('<div class="ads-pool-close-button"><i class="far fa-minus-circle"></i></div>').appendTo($item);
  return $item;
}

export function createAddedItem(label: string, iconClass: string): JQuery {
  const $item = $('<div class="ads-pool-added-item"></div>').text(label);
  $(`<div class="ads-pool-close-button"><i class="${iconClass}"></i></div>`).appendTo($item);
  return $item;
}

export function resetSearchResult(): void {
  $('.audiences-search-result').removeClass('text-danger').empty();
  $('.audiences-search-button').show();
}

export function escapeHtml(s: string): string {
  return s.replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c] as string)
  );
}

export function readFormField($form: JQuery, key: string): string {
  return ($form.find(`[name="${key}"], [name$="[${key}]"]`).first().val() ?? '').toString().trim();
}

export function initTextByteTruncation(): void {
  const inputs = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('.byte-input');
  
  const encoder = new TextEncoder();
  const decoder = new TextDecoder();

  inputs.forEach((input) => {
    const maxBytes = parseInt(input.dataset.maxBytes ?? "255", 10);

    input.addEventListener('input', () => {
      const text = input.value;
      const byteLength = encoder.encode(text).length;

      if (byteLength > maxBytes) {
        const uint8Array = encoder.encode(text);
        const truncatedBuffer = uint8Array.slice(0, maxBytes);
        input.value = decoder.decode(truncatedBuffer);
      }
    });
  });
}
